








import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IReportPosition, ReportPosition } from "@/models/report-position.entity";
import { ZoneTypeEnum } from "@/lib/enum/zone-type.enum";
import { $t } from "@/lib/utility/t";
import {
  MrfiktivBlueprintElementViewmodelGen,
  MrfiktivCoordinatesViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";

@Component
export default class ReportPositionHitZones extends Vue {
  @Prop() blueprint?: MrfiktivBlueprintElementViewmodelGen;
  @Prop() coordinates?: MrfiktivCoordinatesViewModelGen;

  position: IReportPosition | null = null;

  created() {
    this.rebuildPosition();
  }

  @Watch("blueprint", { deep: true })
  onBlueprintChanged() {
    this.rebuildPosition();
  }

  @Watch("coordinates", { deep: true })
  onCoordinatesChanged() {
    this.rebuildPosition();
  }

  rebuildPosition() {
    if (this.blueprint) {
      this.position = new ReportPosition({
        blueprint: this.blueprint,
        coordinates: this.coordinates,
        meta: undefined
      });
    } else {
      this.position = null;
    }
  }

  get hitZonesZones() {
    return this.position?.getHitZonesByType(ZoneTypeEnum.ZONE) || [];
  }

  get hitZonesComponents() {
    return this.position?.getHitZonesByType(ZoneTypeEnum.COMPONENT) || [];
  }

  get hitZonesZonesText() {
    return $t("components.partner.PartnerReportDetailInfoCard.damageLocator.hitZones", {
      name: this.hitZonesZones.map(z => z.name).join(", ")
    });
  }

  get hitZonesComponentsText() {
    return $t("components.partner.PartnerReportDetailInfoCard.damageLocator.hitComponents", {
      name: this.hitZonesComponents.map(z => z.name).join(", ")
    });
  }
}
